import RefundsAPI from '@/API/refunds-api'

export default {
  namespaced: true,
  state: {
    fetched: false,
    noRefunds: false,
  },

  getters: {
    noRefunds: (state: any) => state.noRefunds,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.noRefunds = payload.noOrders ?? false
      state.fetched = true
    },
    RESET_FETCH(state: any) {
      state.fetched = false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any, force = false) {
      if (context.state.fetched && !force) {
        return
      }

      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await RefundsAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    RESET_FETCH(context: any) {
      context.commit('RESET_FETCH')
    },
  },
}
